import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import {User} from '../../../../core/models';

export type UserInviteDialogData = { user: User };
export type UserInviteDialogOutput = string;

@Component({
  selector: 'app-user-invite-dialog',
  templateUrl: './user-invite-dialog.component.html',
  standalone: false
})
export class UserInviteDialogComponent implements OnInit {

  body: FormControl<string> = new FormControl('');

  constructor(
    public dialogRef: MatDialogRef<UserInviteDialogComponent, UserInviteDialogOutput>,
    @Inject(MAT_DIALOG_DATA) private data: UserInviteDialogData
  ) {}

  ngOnInit(): void {
    this.body.setValue(`
Kære ${this.data.user.name}.

Vi har nulstillet din brugerkonto.

Din adgang til systemet sker via brugernavn (emailadresse), adgangskode og sms kode. Sms-koden modtager du hver gang du forsøger at logge ind.

Første gang du logger ind, skal du klikke på "To-trins setup" knappen og lave den adgangskode du vil benytte ved fremtidige login.

Venlig hilsen
Grant Administration
    `);
  }

  confirm(): void {
    this.dialogRef.close(this.body.value);
  }
}
